import { getValue } from "@utils/lodash";
import LegalDetailsSvgComponent from "../../../assets/svg-components/task-details/legal-details";
import ComplianceDetailsSvgComponent from "../../../assets/svg-components/task-details/compliance-details";
import ImpactAssessmentSvgComponent from "../../../assets/svg-components/task-details/impact-assessment";
import * as React from "react";
import { useState } from "react";

// import { UncontrolledAccordion } from "reactstrap";
import {
  UncontrolledAccordion,
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";
import TaskDetailsSvgComponent from "../../../assets/svg-components/task-details/task-details-icon";
import SubmenuArrowDownSvgComponent from "../../../assets/svg-components/left-menu/submenu-arrow-down";
import { formatSmallString } from "@_common/format-text";
import { handleDownloadOnClick } from "@_common/downloadfile";
import DownloadNoCircleSvgComponent from "../../../assets/svg-components/download-nocircle";

// interface ITaskDetailsCommonProps {
//   data: object;
//   documentStore: object;
// }

const TaskDetailsCommon = (props: any) => {
  const { data, documentStore, interlinkedTaskList } = props;

  const [interlinkedTaskListData, setInterlinkedTaskListData] = useState<any>(
    []
  );

  React.useEffect(() => {
    const res = interlinkedTaskList?.map((item: any) => {
      return {
        taskId: item.task_id,
        "Checkpoint Id": item?.self_compliance?.checkpoint?.checkpoint_id,
        Legislation:
          item?.self_compliance?.checkpoint?.legislation?.legislation_name,
        Rule: item?.self_compliance?.checkpoint?.legislation_rule?.rule_name,
        Reference: item?.self_compliance?.checkpoint?.reference,
        "Compliance Activity":
          item?.self_compliance?.checkpoint?.compliance_activity,
        When: item?.self_compliance?.checkpoint?.when,
      };
    });
    setInterlinkedTaskListData(res);
  }, [interlinkedTaskList]);

  // Show More Content for Compliance Activity
  const complianceActivity = getValue(
    data,
    "checkpoint.compliance_activity",
    ""
  );
  const maxCharCount = 100;
  const [showFullContent, setShowFullContent] = useState(false);

  const toggleContent = () => {
    setShowFullContent(!showFullContent);
  };

  const truncatedContent =
    complianceActivity.length > maxCharCount
      ? complianceActivity.substring(0, maxCharCount) + "..."
      : complianceActivity;
  return (
    <div className="map-vendor__search map-vendor__search--task-details pe-3">
      {/* <h4 className="map-vendor__task-title">Task Details</h4> */}
      <div className="d-flex align-items-center master-details-header">
        <TaskDetailsSvgComponent />
        <h4 className="master-details-title">Task Details</h4>
      </div>
      {/* Accordian  */}
      <UncontrolledAccordion
        open="1"
        defaultOpen="1"
        className="task-details-accordian-wrapper"
      >
        {getValue(data, `checkpoint.country.name`, "") ||
        getValue(data, `checkpoint.state.name`, "") ||
        getValue(data, `checkpoint.category_of_law.text`, "") ||
        getValue(data, `checkpoint.ic_checkpoint_id`, "") ||
        getValue(data, `checkpoint.checkpoint_id`, "") ||
        getValue(data, `checkpoint.legislation.legislation_name`, "") ||
        getValue(data, `checkpoint.legislation_rule.rule_name`, "") ||
        getValue(data, `checkpoint.reference`, "") ||
        getValue(data, `checkpoint.who`, "") ||
        getValue(data, `checkpoint.when`, "") ||
        getValue(data, `checkpoint.compliance_activity`, "") ? (
          <AccordionItem>
            <AccordionHeader targetId="1">
              <div className="accordian-header-wrap d-flex align-items-center">
                <LegalDetailsSvgComponent />
                <div className="accordion-header-title">Legal Details</div>
              </div>
            </AccordionHeader>
            <AccordionBody accordionId="1">
              <div className="task-details-accordian-body-wrapper">
                {/* d-flex align-items-start flex-wrap  */}
                <div className="td-accordian-information-wrap">
                  {getValue(data, `checkpoint.country.name`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/country.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Country</p>
                          <h6>
                            {getValue(data, `checkpoint.country.name`, "")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.state.name`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/country.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>State</p>
                          <h6>{getValue(data, `checkpoint.state.name`, "")}</h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.category_of_law.text`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/category-of-law.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Category Of Law</p>
                          <h6>
                            {getValue(
                              data,
                              `checkpoint.category_of_law.text`,
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.ic_checkpoint_id`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/checkpoint-id.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Checkpoint ID</p>
                          <h6>
                            {getValue(data, `checkpoint.ic_checkpoint_id`, "")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.checkpoint_id`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/checkpoint-id.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Checkpoint ID</p>
                          <h6>
                            {getValue(data, `checkpoint.checkpoint_id`, "")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(
                    data,
                    `checkpoint.legislation.legislation_name`,
                    ""
                  ) && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/legislation.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Legislation</p>
                          <h6>
                            {getValue(
                              data,
                              `checkpoint.legislation.legislation_name`,
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(
                    data,
                    `checkpoint.legislation_rule.rule_name`,
                    ""
                  ) && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/rule.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Rule</p>
                          <h6>
                            {getValue(
                              data,
                              `checkpoint.legislation_rule.rule_name`,
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.reference`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/reference.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Reference</p>
                          <h6>{getValue(data, `checkpoint.reference`, "")}</h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.who`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/who.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Who</p>
                          <h6>{getValue(data, `checkpoint.who`, "")}</h6>
                        </div>
                      </div>
                    </div>
                  )}
                  {getValue(data, `checkpoint.when`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/when.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>When</p>
                          <h6>{getValue(data, `checkpoint.when`, "")}</h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.compliance_activity`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/compliance-activity.svg"
                          className="image-fluid td-icon-holder"
                          alt="Compliance Activity Icon"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Compliance Activity</p>
                          <h6>
                            {showFullContent
                              ? complianceActivity
                              : truncatedContent}
                            {complianceActivity.length > maxCharCount && (
                              <span
                                onClick={toggleContent}
                                style={{ cursor: "pointer" }}
                              >
                                {showFullContent ? (
                                  <span
                                    style={{ color: "#276ef1" }}
                                    className="viewLess"
                                  >
                                    &nbsp; View less{" "}
                                    <span
                                      style={{
                                        transform: "rotate(180deg)",
                                        display: "inline-block",
                                      }}
                                    >
                                      {" "}
                                      <SubmenuArrowDownSvgComponent color="#276ef1" />{" "}
                                    </span>
                                  </span>
                                ) : (
                                  <span
                                    style={{ color: "#276ef1" }}
                                    className="viewMore"
                                  >
                                    &nbsp; View more{" "}
                                    <SubmenuArrowDownSvgComponent color="#276ef1" />
                                  </span>
                                )}
                              </span>
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </AccordionBody>
          </AccordionItem>
        ) : null}

        {/* Compliance Details Accordion */}
        {getValue(data, `checkpoint.procedure`, "") ||
        getValue(data, `checkpoint.more_information`, "") ||
        getValue(data, `checkpoint.prohibitive.text`, "") ||
        getValue(data, `checkpoint.frequency.text`, "") ||
        getValue(data, `checkpoint.overall_risk_rating`, "") ||
        getValue(data, `checkpoint.risk`, "") ||
        getValue(data, `checkpoint.process_name`, "") ||
        getValue(data, `checkpoint.regulation`, "") ||
        getValue(data, `checkpoint.period`, "") ||
        getValue(data, `checkpoint.form_no`, "") ||
        getValue(data, `checkpoint.task_type.text`, "") ||
        getValue(data, `checkpoint.level.text`, "") ||
        getValue(data, `checkpoint.exemption_criteria`, "") ||
        getValue(data, `checkpoint.events.text`, "") ||
        getValue(data, `checkpoint.sub_events_id`, "") ||
        getValue(data, `checkpoint.compliance_type.text`, "") ? (
          <AccordionItem>
            <AccordionHeader targetId="2">
              <div className="accordian-header-wrap d-flex align-items-center">
                <ComplianceDetailsSvgComponent />
                <div className="accordion-header-title">Compliance Details</div>
              </div>
            </AccordionHeader>
            <AccordionBody accordionId="2">
              <div className="task-details-accordian-body-wrapper">
                <div className="td-accordian-information-wrap">
                  {getValue(data, `checkpoint.procedure`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/procedure.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Procedure</p>
                          <h6>{getValue(data, `checkpoint.procedure`, "")}</h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.more_information`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/more-info.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>More Information</p>
                          <h6>
                            {getValue(data, `checkpoint.more_information`, "")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.prohibitive.text`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/prohibitive.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Prohibitive/Prescriptive</p>
                          <h6>
                            {getValue(data, `checkpoint.prohibitive.text`, "")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.frequency.text`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/frequency.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Frequency</p>
                          <h6>
                            {getValue(data, `checkpoint.frequency.text`, "")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.overall_risk_rating`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/checkpoint-id.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Overall Risk Rating</p>
                          <h6>
                            {getValue(
                              data,
                              `checkpoint.overall_risk_rating`,
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.risk`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/checkpoint-id.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Risk</p>
                          <h6>{getValue(data, `checkpoint.risk`, "")}</h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.process_name`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/checkpoint-id.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Process Name</p>
                          <h6>
                            {getValue(data, `checkpoint.process_name`, "")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}
                  {getValue(data, `checkpoint.regulation`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/checkpoint-id.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Regulation</p>
                          <h6>{getValue(data, `checkpoint.regulation`, "")}</h6>
                        </div>
                      </div>
                    </div>
                  )}
                  {getValue(data, `checkpoint.activity`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/checkpoint-id.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Activity</p>
                          <h6>{getValue(data, `checkpoint.activity`, "")}</h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.form_no`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/form-no.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Form No</p>
                          <h6>{getValue(data, `checkpoint.form_no`, "")}</h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* {getValue(data, `checkpoint.task_type.text`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/task-type.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Task Type</p>
                          <h6>
                            {getValue(data, `checkpoint.task_type.text`, "")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )} */}

                  {getValue(data, `checkpoint.compliance_type.text`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/checkpoint-id.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Compliance Type </p>
                          <h6>
                            {getValue(
                              data,
                              `checkpoint.compliance_type.text`,
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.level.text`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/level.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Level</p>
                          <h6>{getValue(data, `checkpoint.level.text`, "")}</h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.exemption_criteria`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/excemption-criteria.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Exemption Criteria</p>
                          <h6>
                            {getValue(
                              data,
                              `checkpoint.exemption_criteria`,
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.events.text`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/events.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Events</p>
                          <h6>
                            {getValue(data, `checkpoint.events.text`, "")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.sub_events_id`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/events.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Sub Events ID</p>
                          <h6>
                            {getValue(data, `checkpoint.sub_events_id`, "")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </AccordionBody>
          </AccordionItem>
        ) : null}

        {getValue(data, `checkpoint.impact.text`, "") ||
        getValue(data, `checkpoint.impact_on_unit.text`, "") ||
        getValue(data, `checkpoint.impact_on_vertical.text`, "") ||
        getValue(data, `checkpoint.impact_on_organization.text`, "") ||
        getValue(data, `checkpoint.inter_linkage`, "") ||
        getValue(data, `checkpoint.linked_task_id`, "") ||
        getValue(data, `checkpoint.document_type.text`, "") ||
        getValue(data, `checkpoint.implication`, "") ||
        getValue(data, `checkpoint.imprisonment_duration`, "") ||
        getValue(data, `checkpoint.imprisonment_applies.text`, "") ||
        getValue(data, `checkpoint.fine_amount`, "") ||
        getValue(data, `checkpoint.subsequent_amount_per_day`, "") ? (
          <AccordionItem>
            <AccordionHeader targetId="3">
              <div className="accordian-header-wrap d-flex align-items-center">
                <ImpactAssessmentSvgComponent />
                <div className="accordion-header-title">Impact Assessment</div>
              </div>
            </AccordionHeader>
            <AccordionBody accordionId="3">
              <div className="task-details-accordian-body-wrapper">
                <div className="td-accordian-information-wrap">
                  {getValue(data, `checkpoint.impact.text`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/impact.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Impact</p>
                          <h6>
                            {getValue(data, `checkpoint.impact.text`, "")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.impact_on_unit.text`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/impact-unit.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Impact on Unit</p>
                          <h6>
                            {getValue(
                              data,
                              `checkpoint.impact_on_unit.text`,
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.impact_on_vertical.text`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/impact-unit.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Impact on Vertical</p>
                          <h6>
                            {getValue(
                              data,
                              `checkpoint.impact_on_vertical.text`,
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(
                    data,
                    `checkpoint.impact_on_organization.text`,
                    ""
                  ) && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/impact-org.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Impact on Organization</p>
                          <h6>
                            {getValue(
                              data,
                              `checkpoint.impact_on_organization.text`,
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}
                  {getValue(data, `checkpoint.implication`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/implication.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Implication</p>
                          <h6>
                            {getValue(data, `checkpoint.implication`, "")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.imprisonment_duration`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/imprisonment-duration.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Imprisonment Duration</p>
                          <h6>
                            {getValue(
                              data,
                              `checkpoint.imprisonment_duration`,
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(
                    data,
                    `checkpoint.imprisonment_applies.text`,
                    ""
                  ) && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/imprisonment-applies.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Imprisonment Applies to</p>
                          <h6>
                            {getValue(
                              data,
                              `checkpoint.imprisonment_applies.text`,
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.fine_amount`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/fine.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Fine Amount (INR)</p>
                          <h6>
                            {getValue(data, `checkpoint.fine_amount`, "")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(
                    data,
                    `checkpoint.subsequent_amount_per_day`,
                    ""
                  ) && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/fine.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Subsequent Amount per Day (INR)</p>
                          <h6>
                            {getValue(
                              data,
                              `checkpoint.subsequent_amount_per_day`,
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}
                  {getValue(data, `checkpoint.inter_linkage`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/interlinkage.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Interlinkage</p>
                          <h6>
                            {getValue(data, `checkpoint.inter_linkage`, "")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.linked_task_id`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/checkpoint-id.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Linked task id</p>
                          <h6>
                            {getValue(data, `checkpoint.linked_task_id`, "")}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}

                  {getValue(data, `checkpoint.document_type.text`, "") && (
                    <div className="td-accordian-information">
                      <div>
                        <img
                          src="/images/task-details-accordion-icons/doc-type.svg"
                          className="image-fluid td-icon-holder"
                        />
                        <div className="td-info-label-value-wrap">
                          <p>Document Type</p>
                          <h6>
                            {getValue(
                              data,
                              `checkpoint.document_type.text`,
                              ""
                            )}
                          </h6>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </AccordionBody>
          </AccordionItem>
        ) : null}
        {interlinkedTaskList &&
        interlinkedTaskList?.length &&
        interlinkedTaskListData?.length ? (
          <AccordionItem>
            <AccordionHeader targetId="4">
              <div className="accordian-header-wrap d-flex align-items-center">
                <ComplianceDetailsSvgComponent />
                <div className="accordion-header-title">
                  Interlinked Task Details
                </div>
              </div>
            </AccordionHeader>
            <AccordionBody accordionId="4">
              <div className="task-details-accordian-body-wrapper">
                <div className="ps-5">
                  {interlinkedTaskListData?.map((item: any, index: number) => (
                    <div key={index}>
                      <div className="">
                        <h6>
                          <p>{item?.taskId}</p>
                        </h6>
                      </div>

                      <div className="td-accordian-information-wrap">
                        {Object.entries(item).map(
                          ([key, value]: any) =>
                            key !== "taskId" && (
                              <div
                                className="td-accordian-information"
                                key={key}
                              >
                                <div className="td-info-label-value-wrap">
                                  <p>{key}</p>
                                  <h6>{value}</h6>
                                </div>
                              </div>
                            )
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </AccordionBody>
          </AccordionItem>
        ) : null}
      </UncontrolledAccordion>

      {getValue(props, `documentStore`, []).map((item: any) => (
        <>
          <div className="download-checkpoint">
            <h4 className="master-details-title">Reference Document</h4>
          </div>
          <div
            // className="attach-files-wrapper__files cursor-pointer d-flex justify-content-between mt-2"
            key={item.id}
          >
            {getValue(item, `documents`, []).map((document: any) => (
              <>
                <div
                  className="attach-files-wrapper__files cursor-pointer d-flex justify-content-between mt-2"
                  key={item.id}
                >
                  <p
                    key={document.id}
                    style={{
                      fontSize: "12px",
                      marginTop: "0px",
                      textAlign: "center",
                    }}
                    onClick={() =>
                      handleDownloadOnClick(document.url, document.name)
                    }
                  >
                    {formatSmallString(document.name)}
                  </p>

                  <DownloadNoCircleSvgComponent size={18} />
                </div>
              </>
            ))}
          </div>
        </>
      ))}

      {/* {getValue(data, `checkpoint.ic_checkpoint_id`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/checkpoint.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Checkpoint ID</p>
            <h6>{getValue(data, `checkpoint.ic_checkpoint_id`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.checkpoint_id`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/checkpoint.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Checkpoint ID</p>
            <h6>{getValue(data, `checkpoint.checkpoint_id`, "")}</h6>
          </div>
        </div>
      )}

      {getValue(data, `checkpoint.country.name`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/checkpoint.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Country</p>
            <h6>{getValue(data, `checkpoint.country.name`, "")}</h6>
          </div>
        </div>
      )}

      {getValue(data, `checkpoint.state.name`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/checkpoint.svg" className="image-fluid" />
          <div className="mx-2">
            <p>State</p>
            <h6>{getValue(data, `checkpoint.state.name`, "")}</h6>
          </div>
        </div>
      )}

      {getValue(data, `checkpoint.category.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/checkpoint.svg" className="image-fluid" />
          <div className="mx-2">
            <p>category</p>
            <h6>{getValue(data, `checkpoint.category.text`, "")}</h6>
          </div>
        </div>
      )}

      {getValue(data, `checkpoint.period.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/checkpoint.svg" className="image-fluid" />
          <div className="mx-2">
            <p>period</p>
            <h6>{getValue(data, `checkpoint.period.text`, "")}</h6>
          </div>
        </div>
      )}

      {getValue(data, `checkpoint.control_frequency.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/checkpoint.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Control Frequency</p>
            <h6>{getValue(data, `checkpoint.control_frequency.text`, "")}</h6>
          </div>
        </div>
      )}

      {getValue(data, `checkpoint.overall_risk_rating`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/checkpoint.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Overall Risk Rating</p>
            <h6>{getValue(data, `checkpoint.overall_risk_rating`, "")}</h6>
          </div>
        </div>
      )}

      {getValue(data, `checkpoint.risk`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/checkpoint.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Risk</p>
            <h6>{getValue(data, `checkpoint.risk`, "")}</h6>
          </div>
        </div>
      )}

      {getValue(data, `checkpoint.process_name`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/checkpoint.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Process Name</p>
            <h6>{getValue(data, `checkpoint.process_name`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.regulation`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/checkpoint.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Regulation</p>
            <h6>{getValue(data, `checkpoint.regulation`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.activity`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/checkpoint.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Activity</p>
            <h6>{getValue(data, `checkpoint.activity`, "")}</h6>
          </div>
        </div>
      )}

      {getValue(data, `checkpoint.frequency.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/task-details-img2.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Frequency</p>
            <h6>{getValue(data, `checkpoint.frequency.text`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.category_of_law.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/task-details-img3.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Category Of Law</p>
            <h6>{getValue(data, `checkpoint.category_of_law.text`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.legislation.legislation_name`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/task-details-img4.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Legislation</p>
            <h6>
              {getValue(data, `checkpoint.legislation.legislation_name`, "")}
            </h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.legislation_rule.rule_name`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/task-details-img5.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Rule</p>
            <h6>
              {getValue(data, `checkpoint.legislation_rule.rule_name`, "")}
            </h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.compliance_activity`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/task-details-img6.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Compliance Activity</p>
            <h6>{getValue(data, `checkpoint.compliance_activity`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `location.location_name`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/task-details-img7.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Location</p>
            <h6>{getValue(data, `location.location_name`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `license_type.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/task-details-img7.svg" className="image-fluid" />
          <div className="mx-2">
            <p>License Type</p>
            <h6>{getValue(data, `license_type.text`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.who`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/who.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Who</p>
            <h6>{getValue(data, `checkpoint.who`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.when`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/when.svg" className="image-fluid" />
          <div className="mx-2">
            <p>When</p>
            <h6>{getValue(data, `checkpoint.when`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.reference`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/reference.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Reference</p>
            <h6>{getValue(data, `checkpoint.reference`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.procedure`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/procedure.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Procedure</p>
            <h6>{getValue(data, `checkpoint.procedure`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.more_information`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/more-information.svg" className="image-fluid" />
          <div className="mx-2">
            <p>More Information</p>
            <h6>{getValue(data, `checkpoint.more_information`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.prohibitive.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/prohebitive.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Prohibitive/Prescriptive</p>
            <h6>{getValue(data, `checkpoint.prohibitive.text`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.task_type.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/type-of-task.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Type of Task</p>
            <h6>{getValue(data, `checkpoint.task_type.text`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.level.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/level.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Level</p>
            <h6>{getValue(data, `checkpoint.level.text`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.form_no`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/form-no.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Form No</p>
            <h6>{getValue(data, `checkpoint.form_no`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.document_type.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/document-type.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Document Type</p>
            <h6>{getValue(data, `checkpoint.document_type.text`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.compliance_type.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/compliance-type.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Compliance Type </p>
            <h6>{getValue(data, `checkpoint.compliance_type.text`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.impact.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/impact.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Impact</p>
            <h6>{getValue(data, `checkpoint.impact.text`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.impact_on_organization.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/impact-organization.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Impact on Organization</p>
            <h6>
              {getValue(data, `checkpoint.impact_on_organization.text`, "")}
            </h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.impact_on_unit.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/impact-organization.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Impact on Unit</p>
            <h6>{getValue(data, `checkpoint.impact_on_unit.text`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.imprisonment_applies.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/imprisement-applies.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Imprisonment Applies to</p>
            <h6>
              {getValue(data, `checkpoint.imprisonment_applies.text`, "")}
            </h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.implication`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/implication.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Implication</p>
            <h6>{getValue(data, `checkpoint.implication`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.imprisonment_duration`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/imprisement-duration.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Imprisonment Duration</p>
            <h6>{getValue(data, `checkpoint.imprisonment_duration`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.fine_amount`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/fine-amount.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Fine Amount (INR)</p>
            <h6>{getValue(data, `checkpoint.fine_amount`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.subsequent_amount_per_day`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/sub-sequent.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Subsequent Amount per Day (INR)</p>
            <h6>
              {getValue(data, `checkpoint.subsequent_amount_per_day`, "")}
            </h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.events.text`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/events.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Events</p>
            <h6>{getValue(data, `checkpoint.events.text`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.exemption_criteria`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/exemption.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Exemption Criteria</p>
            <h6>{getValue(data, `checkpoint.exemption_criteria`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.inter_linkage`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/inter-linkage.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Inter Linkage</p>
            <h6>{getValue(data, `checkpoint.inter_linkage`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.linked_task_id`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/link-task.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Linked Task ID</p>
            <h6>{getValue(data, `checkpoint.linked_task_id`, "")}</h6>
          </div>
        </div>
      )}
      {getValue(data, `checkpoint.sub_events_id`, "") && (
        <div className="mb-3 d-flex align-items-start">
          <img src="/images/sub-event.svg" className="image-fluid" />
          <div className="mx-2">
            <p>Sub Events ID</p>
            <h6>{getValue(data, `checkpoint.sub_events_id`, "")}</h6>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default TaskDetailsCommon;
